/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateDomainRequestBody,
  CreateDomainRequestBody$Outbound,
  CreateDomainRequestBody$outboundSchema,
} from "../components/createdomainrequestbody.js";

export type RegisterDomainSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RegisterDomainRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createDomainRequestBody: CreateDomainRequestBody;
};

/** @internal */
export type RegisterDomainSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RegisterDomainSecurity$outboundSchema: z.ZodMiniType<
  RegisterDomainSecurity$Outbound,
  RegisterDomainSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function registerDomainSecurityToJSON(
  registerDomainSecurity: RegisterDomainSecurity,
): string {
  return JSON.stringify(
    RegisterDomainSecurity$outboundSchema.parse(registerDomainSecurity),
  );
}

/** @internal */
export type RegisterDomainRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateDomainRequestBody: CreateDomainRequestBody$Outbound;
};

/** @internal */
export const RegisterDomainRequest$outboundSchema: z.ZodMiniType<
  RegisterDomainRequest$Outbound,
  RegisterDomainRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createDomainRequestBody: CreateDomainRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createDomainRequestBody: "CreateDomainRequestBody",
    });
  }),
);

export function registerDomainRequestToJSON(
  registerDomainRequest: RegisterDomainRequest,
): string {
  return JSON.stringify(
    RegisterDomainRequest$outboundSchema.parse(registerDomainRequest),
  );
}
